mutation stopAllCampaignsForLead($input: StopAllCampaignsForLeadInput!) {
  unsubscribeLead: stopAllCampaignsForLead(input: $input)
}
